export const urlConstants = {
    API_URL: process.env.REACT_APP_API_URL,
    IMAGE_ASSET_URL:process.env.REACT_APP_IMAGE_ASSET_URL,
    IMAGE_BASE_URL:process.env.REACT_APP_IMAGE_BASE_URL,
}